//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      groupName: null,
      fieldType: null
    };
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.groupElement = this.$el.closest("[data-component=checkGroup]");
      var groupName = null;
      this.$type.ifObject(this.groupElement, function (val) {
        return groupName = val.getAttribute("name");
      });
      this.fieldName = this.spec.name || groupName;
      this.fieldModel = this.spec.checked ? this.spec.checkValue : this.spec.value;
      Utils.type.ifArray(this.spec.styleClasses, function (classes) {
        if (classes.remove("switch")) {
          _this.fieldType = "switch";
        }
      });
    },
    changed: function changed(event) {
      var _this2 = this;

      // Execute later to ensure the checkbox's checked state has been updated.
      setTimeout(function () {
        _this2.$type.ifObject(_this2.groupElement, function (val) {
          return val.dispatchEvent(new Event("change"));
        });
      }, 100); // if (this.spec.submitOnChange) {
      //   setTimeout(() => {
      //     this.$dispatchEvent("forms/submit");
      //   }, 200);
      // }

      Utils.type.ifObject(this.spec.onChange, function (onChange) {
        _this2.$nextTick(function () {
          GLib.action.execute(onChange, _this2);
        });
      });
    },
    $internalizeValue: function $internalizeValue(val) {
      if (val == this.spec.checkValue) {
        return val;
      }

      return this.spec.uncheckValue;
    }
  }
};